import { Button } from "@/components/ui/button";
import { FileText, Check, Loader2 } from "lucide-react";
import { useBuyGuide } from "@/components/jobbkarta/useBuyGuide";

const POINTS = [
  "Konkret tidslinje: när och hur ofta du följer upp – och när du ska sluta",
  "Färdiga mallar för uppföljningsmejl i flera toner, med ämnesrader",
  "De vanligaste misstagen och hur du undviker dem",
  "Hur du avslutar snyggt och håller dörren öppen för framtiden",
];

export const GuideCard = () => {
  const { buy, loading } = useBuyGuide();
  return (
    <div
      data-testid="guide-card"
      className="jk-fade-up mt-12 w-full overflow-hidden rounded-3xl border border-emerald-200 bg-gradient-to-br from-emerald-50 to-white p-6 text-left shadow-sm sm:p-8"
    >
      <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
        <div className="max-w-xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-emerald-600/10 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-emerald-700">
            <FileText className="h-3.5 w-3.5" /> Uppföljningsguide · PDF
          </span>
          <h3 className="mt-3 font-display text-2xl font-extrabold tracking-tight text-slate-900">
            Uppföljning efter spontanansökan
          </h3>
          <p className="mt-1 text-sm leading-relaxed text-slate-600">
            Det är uppföljningen som avgör. Få en konkret plan och färdiga mejlmallar
            som hjälper dig att faktiskt få svar – och jobbet.
          </p>
          <ul className="mt-4 space-y-2">
            {POINTS.map((p, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-slate-700">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex shrink-0 flex-col items-center gap-1.5 rounded-2xl border border-emerald-100 bg-white p-5 text-center shadow-sm sm:w-56">
          <div className="font-display text-4xl font-extrabold text-slate-900">
            89<span className="ml-1 text-lg font-bold text-slate-500">kr</span>
          </div>
          <div className="text-xs text-slate-500">engångsköp · direkt nedladdning</div>
          <Button
            onClick={buy}
            disabled={loading}
            data-testid="buy-guide-btn"
            className="mt-3 h-11 w-full gap-2 rounded-full bg-emerald-600 px-5 text-base hover:bg-emerald-700"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileText className="h-4 w-4" />}
            Köp guiden
          </Button>
          <div className="mt-1 text-[11px] text-slate-400">Säker betalning · inget konto behövs</div>
          <p
            data-testid="guide-card-no-withdrawal-note"
            className="mt-2 text-[11px] leading-relaxed text-slate-400"
          >
            Digital produkt som levereras direkt – <b className="text-slate-600">ingen ångerrätt</b>,
            köpet kan inte återbetalas.{" "}
            <a
              href="/kopvillkor"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-emerald-700 underline hover:text-emerald-800"
            >
              Köpvillkor
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
